import angular from "angular";

angular
	.module('app')
	.component('notificationCourseResumed', {
		template: require('./notification-course-resumed.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });
            
function controller($http) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.notify = $ctrl.resolve.notification;
    };
}